import React from 'react';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';


const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  padding: 10px 30px;
  border-bottom: 1px solid var(--line-gray);
  background-color:  var(--line-gray);
  &:not(:first-child) {
    border-top: 1px solid var(--line-gray);
  }
`;

const Text = styled.div`
  font-size: 14px;
  color: var(--text-primary);
  padding-top: 4px;
`;



const ShopDataModalFeesReminder = () => {

    return (
        <Container>
            <ExclamationCircleOutlined style={{ fontSize: '16px' }} />
            <Text>When entering fees, an empty field implies 'not offered' and entering $0 implies 'free of charge', in most cases.</Text>
        </Container>
    );
};

export default ShopDataModalFeesReminder;
